import React, { useState } from 'react';
import { AliasEmailEntry } from './alias-email-entry';
import { AliasOtpVerify } from './alias-otp-verify';

export function AddAliasModalSteps({ onClose, aliases }) {
    const [alias, setAlias] = useState('');

    return (
        <div className='settingsModalContent'>
            {alias ? (
                <AliasOtpVerify alias={alias} onClose={onClose} />
            ) : (
                <AliasEmailEntry alias={alias} onClose={onClose} setAlias={setAlias} aliases={aliases} />
            )}
        </div>
    );
}
